
import React from 'react';
import AdminLayout from '@/components/admin/AdminLayout';
import { useAdminSettings } from '@/hooks/useAdminSettings';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowLeft, DollarSign, Users, FileText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import AuthorizedUsersTable from '@/components/AuthorizedUsersTable';
import ReferrerPaymentManagement from '@/components/admin/ReferrerPaymentManagement';
import PointsRedemptionReport from '@/components/admin/PointsRedemptionReport';
import { useRedemptionStats } from '@/hooks/useRedemptionStats';

const AdminReports = () => {
  const navigate = useNavigate();
  const { isLoading, user, handleLogout } = useAdminSettings();
  const redemptionStats = useRedemptionStats();

  return (
    <AdminLayout
      isLoading={isLoading}
      onLogout={handleLogout}
      userRole={user?.role}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate('/admin/dashboard')}
          className="mb-4"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Dashboard
        </Button>
        
        <h1 className="text-2xl font-bold mb-6">Reports</h1>
        
        <Tabs defaultValue="users" className="space-y-4">
          <TabsList>
            <TabsTrigger value="users" className="flex items-center">
              <Users className="h-4 w-4 mr-2" />
              Users Report
            </TabsTrigger>
            <TabsTrigger value="payments" className="flex items-center">
              <DollarSign className="h-4 w-4 mr-2" />
              Payment Reports
            </TabsTrigger>
            <TabsTrigger value="redemptions" className="flex items-center">
              <FileText className="h-4 w-4 mr-2" />
              Points Redemption
            </TabsTrigger>
          </TabsList>

          <TabsContent value="users">
            <Card>
              <CardHeader>
                <CardTitle>Authorized Users Report</CardTitle>
                <CardDescription>
                  Comprehensive overview of users authorized to use the system.
                </CardDescription>
              </CardHeader>
              <CardContent>
                <AuthorizedUsersTable users={[]} />
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="payments">
            <ReferrerPaymentManagement />
          </TabsContent>

          <TabsContent value="redemptions">
            <PointsRedemptionReport />
          </TabsContent>
        </Tabs>
      </div>
    </AdminLayout>
  );
};

export default AdminReports;
